import React from 'react';
import { Receipt } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import ModuleAlertsPage from '../../shared/components/ModuleAlertsPage';
import { useFacturationConfig } from './useFacturationConfig';

const FacturationAlertsPage = () => {
  useFacturationConfig();
  const { t } = useTranslation();
  const p = (key) => t(`modules.facturation.pages.facturationAlertsPage.${key}`);

  const alerts = [
    {
      id: 1,
      type: 'warning',
      priority: 'high',
      title: p('alert_unpaid_title'),
      message: p('alert_unpaid_message'),
      date: new Date().toISOString().split('T')[0],
      read: false,
      amount: 2450000
    },
    {
      id: 2,
      type: 'info',
      priority: 'medium',
      title: p('alert_quotes_pending_title'),
      message: p('alert_quotes_pending_message'),
      date: new Date(Date.now() - 86400000).toISOString().split('T')[0],
      read: false
    },
    {
      id: 3,
      type: 'success',
      priority: 'low',
      title: p('alert_payment_received_title'),
      message: p('alert_payment_received_message'),
      date: new Date(Date.now() - 172800000).toISOString().split('T')[0],
      read: true,
      amount: 3500000
    }
  ];

  return <ModuleAlertsPage moduleName={p('module_name')} moduleIcon={Receipt} alerts={alerts} />;
};

export default FacturationAlertsPage;
